import { useMutation, useQueryClient } from "@tanstack/react-query";
import { togglePublished } from "../api";
import { themesKeys } from "../queries/index";

interface TogglePublishedParams {
  id: number;
  value: boolean;
}

export const useTogglePublishedMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, value }: TogglePublishedParams) => {
      const response = await togglePublished(id, value);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: themesKeys.all });
    },
  });
};
